import { useState } from 'react'
// import { aboveTypes } from './types'

export const useBlurAndAbove = () => {
  const [blur, setblur] = useState<boolean>(false)
  const [unBlur, setunBlur] = useState<boolean>(false)
  const [settingsUnblur, setsettingsUnblur] = useState<boolean>(false)
  const [above, setabove] = useState<any>(false)

  const handleAbove = (a: any) => {
    if (!!a) {
      setblur(true)
      setunBlur(false)
      setTimeout(() => {
        setabove(a)
      }, 50)
    } else {
      setunBlur(true)
      setTimeout(() => {
        setblur(false)
        setabove(a)
      }, 50)
    }
    if (a === 'Provably Fair' || a === 'History' || a === 'Game Rules') {
      setsettingsUnblur(true)
      setTimeout(() => {
        setsettingsUnblur(false)
      }, 1000)
    }
  }
  return [blur, unBlur, settingsUnblur, above, handleAbove]
}
